
@defer (when isLoading === false) {
  @if (seasons?.length) {
    <ion-item class="season-selector">
      <ion-select style="width: 120px; justify-content: center; align-items: center;" interface="popover" [value]="0" placeholder="{{'Select season' | translate}}" (ionChange)="emitSeason($event)">
          <ion-select-option *ngFor="let s of seasons; let i = index" [value]="i">{{ s.name }}</ion-select-option>
      </ion-select>
    </ion-item>
  }
} @loading () {
  <ion-spinner name="crescent"></ion-spinner>
}


